import { OktaAuth } from '@okta/okta-auth-js';

// JobGenOpenOICD
//oktaConfigBaseUrl = 'dev-66170580.okta.com';
//oktaConfigClientId = '0oakb7ttgmqidDdFT5d7'

var oktaConfigBaseUrl = process.env.REACT_APP_OKTA_BASE_URL;
var oktaConfigClientId = process.env.REACT_APP_OKTA_CLIENT_ID;

export const oktaAuthConfig = {
    issuer: `https://${oktaConfigBaseUrl}`,
    clientId: oktaConfigClientId,
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: ["openid", "profile", "email"],
    pkce: true, // Enable PKCE
};

export const oktaDisabledFakeUserInfo = {
    "sub": "00u8xbdridBo5wpkq0x7",
    "name": "OKTA Disabled fake user",
    "locale": "FR",
    "email": "okta.disabled@external.engie.com",
    "preferred_username": "okta.disabled@engie.com",
    "given_name": "Fake",
    "family_name": "User",
    "zoneinfo": "America/Los_Angeles",
    "email_verified": true,
    "lastName": "Fake",
    "firstName": "User",
};

export const oktaEnabled = !!(oktaConfigBaseUrl && oktaConfigClientId);
export const runningOnLocalhost = (window.location.hostname === 'localhost')

// Create an instance of OktaAuth 
export const oktaAuth = new OktaAuth(oktaAuthConfig); // Create the instance

export const apiGatewayConfig = {

    //apiBaseUrl: "https://q7h3vkcd47.execute-api.eu-west-3.amazonaws.com/JobGenIA",
    apiBaseUrl: process.env.REACT_APP_API_GATEWAY_BASE_URL,

    endpointJobAdReferentials: "JobAdReferentials",
    endpointJobAdGeneration: "JobAdGeneration",
    endpointJobAdRefine: "JobAdRefine",
    endpointJobAdTranslation: "JobAdTranslation",
    endpointJobAdGenderEvaluator: 'JobAdGenderEvaluator',
    endpointJobAdLanguageComplexity: 'JobAdLanguageComplexity',
    endpointJobAdSeoScore: 'JobAdSeoScore',
    endpointJobAdGuidelinesCompliance: 'JobAdGuidelinesCompliance',
    endpointLogsGetItemsForFunction: 'LogsGetItemsForFunction',
    endpointLogUpdateItem: 'LogUpdateItem',
    endpointGenderBalance: 'JobAdGenderBalance',
    endpointJobAdInfoList: 'JobAdInfoList',
    endpointJobAdInfoCreateUpdate: 'JobAdInfoCreateUpdate',
    endpointJobAdInfoDelete: 'JobAdInfoDelete',
    endpointJagFeedback: 'JobAdFeedback',
    endpointAdminPromptSystemManagement: 'admin/PromptSystemManagement',
    endpointAdminDataManagement: 'admin/DataManagement',
    endpointAdminDataUpload: 'admin/DataUpload',
}

export const modelProviders = [
    'bedrock/eu.anthropic.claude-3-5-sonnet-20240620-v1:0',
    'openai/gpt-4o-mini',
//    'openai/gpt-4o-jag',
//    'openai/gpt-3.5-turbo',
    'bedrock/anthropic.claude-3-haiku-20240307-v1:0',
    'bedrock/anthropic.claude-3-sonnet-20240229-v1:0',
]

export const maxJobDescriptionLength = 10000; // Max length of job description in characters
